import { dataURItoFile } from '../helpers/avatar-util';
const updateUserAvatar = async (_, args, context) => {
  const {
    userId,
    fileURI
  } = args;
  const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
  const fileObject = dataURItoFile(fileURI);
  const formData = new FormData();
  formData.append('file', fileObject);
  const fetchOptions = {
    method: 'PUT',
    body: formData,
    headers: {
      'Content-Type': undefined
    }
  };
  return context
  // @ts-ignore: we want to not pass 'Content-Type' header explicitly
  .fetch(url, fetchOptions)
  // Although current API in id-public-api-facade does not return new uploaded avatar,
  // we still want to have it in client-side
  .then(() => ({
    url: fileURI
  }));
};
export default updateUserAvatar;